import * as React from "react";
import {Bootstrap} from "PageBuilder/Bootstrap";
import ReactDOM = require("react-dom");
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import 'shared/styles/bootstrap.scss';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faSearch} from "@fortawesome/free-solid-svg-icons/faSearch";
import {RNDatePicker} from "shared/controls/SingleInputs/RNDatePicker/RNDatePicker";
import {SpinnerButton} from "shared/controls/SpinnerButton";
import {WpAjaxPost} from "shared/utilities/ajax/WPAjaxPost";
import {WPTable} from "shared/controls/WPTable/WPTable";
import {WPBasicColumn, WPBasicColumnProps} from "shared/controls/WPTable/Columns/WPBasicColumn";
import moment = require("moment");
import {FormatterFactory} from "./Formatters/Core/FormatterFactory";
import {faFilePdf} from "@fortawesome/free-solid-svg-icons/faFilePdf";
import {css} from "emotion";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {TemplatePicker} from "./Dialogs/TemplatePicker";
import {faTrash} from "@fortawesome/free-solid-svg-icons/faTrash";
import {DeleteDialog} from "shared/controls/Dialogs/premade/DeleteDialog";
import {ToastService} from "shared/utilities/services/ToastService";

import './Styles.css';
library.add(faSearch);
library.add(faFilePdf);
library.add(faTrash);
moment().utcOffset(rednaoEntries.Offset*60);
export class EntriesBootstrap extends React.Component<EntriesBootstrapProps, EntriesBootstrapState> {
    static defaultProps: Partial<EntriesBootstrapProps> = {};

    constructor(props: EntriesBootstrapProps) {
        super(props);
        WpAjaxPost.SetGlobalVar(rednaoEntries);
        this.state = {
            EndDate:0,
            FormId:rednaoEntries.FormList.length>0?rednaoEntries.FormList[0].Id as any:null,
            StartDate:0,
            IsBusy:false,
            IsValid:true,
            ErrorMessage:'',
            Size:30,
            PageIndex:0,
            Form:null,
            RowCount:0,
            Rows:[]

        };
    }

    public render() {

        return (
            <div className={'rednao'} style={{padding:10}}>
                <fieldset style={{border:'1px solid #dfdfdf', padding:10,backgroundColor:'#f9f9f9',borderRadius:10}}>
                    <legend><strong><FontAwesomeIcon icon={"search"}/> Search Criteria</strong></legend>
                    <SearchableSelect IsValid={this.state.IsValid} ErrorMessage={this.state.ErrorMessage} Required={true} onChange={e=>this.setState({FormId:e as any})} Value={this.state.FormId} Label={'Form'} placeholder={'Please select a form'} style={{display:'inline-block',width:250,marginRight:5}}>
                        {rednaoEntries.FormList.map(x=>
                            <option key={x.Id} value={x.Id}>{x.Name}</option>
                        )}
                    </SearchableSelect>

                    <RNDatePicker Value={this.state.StartDate} onChange={e=>this.setState({StartDate:e as any})} Label={'Start Date'} style={{display:'inline-block',marginRight:5}}/>
                    <RNDatePicker Value={this.state.EndDate} onChange={e=>this.setState({EndDate:e as any})} Label={'End Date'} style={{display:'inline-block',marginRight:5}}/>
                    <SpinnerButton IsBusy={this.state.IsBusy} OnClick={()=>this.Search(this.state.FormId,0)} Icon={'search'} AddLabelMargin={true} style={{marginLeft:5}}>Search</SpinnerButton>
                </fieldset>

                <div style={{marginTop:20}}>
                    {this.state.Form!=null?
                        <div>

                        <WPTable BulkActions={[
                            {Title:'View',CallBack: ()=>this.BulkView()}
                            ]} IsBusy={this.state.IsBusy} Data={this.state.Rows} Size={this.state.Size} RowsCount={this.state.RowCount} PageIndex={this.state.PageIndex} PageChanged={e=>this.Search(this.state.Form.Id,e)}>
                            <WPBasicColumn Width={25} PropertyName={'_sel'}>
                                {(row,instance)=>{return <input checked={row._sel} type={'checkbox'} value={row._sel} onChange={e=>{row._sel=e.target.checked;instance.forceUpdate();}}/>}}
                            </WPBasicColumn>
                            <WPBasicColumn HeaderStyle={{textAlign:"center"}} PropertyName={'actions'} Title={'Actions'} Width={80} >
                                {row=>
                                    <div key={'actions'} style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                                        <div  style={{textAlign:'center'}}>
                                            <span onClick={e=>this.Delete(row._id)} title={'View PDF'} style={{cursor:'pointer',fontSize:20,marginRight:10}} className={css`&:hover{color:red}`}>
                                                <FontAwesomeIcon icon={"trash"}/>
                                            </span>
                                        </div>
                                        <div  style={{textAlign:'center'}}>
                                            <span onClick={e=>this.ViewPDF([row._id])} title={'View PDF'} style={{cursor:'pointer',fontSize:20}} className={css`&:hover{color:red}`}>
                                                <FontAwesomeIcon icon={"file-pdf"}/>
                                            </span>
                                        </div>
                                    </div>
                                }
                            </WPBasicColumn>
                            <WPBasicColumn Title={'Date'} PropertyName={'_date'} Formatter={(value, column, row) => this.FormatColumn(value,column,row)}/>
                            {this.state.Form.Fields.map(x=>
                                <WPBasicColumn Width={200} key={this.state.Form.Id+'_'+x.Id}  PropertyName={'f'+x.Id} Title={x.Label} Formatter={(value, column, row) => this.FormatColumn(value,column,row)}/>
                            )}
                        </WPTable>
                        </div>:
                        <div style={{backgroundColor:'#f9f9f9',padding:20,textAlign:'center',borderRadius:10,border:'1px solid #dfdfdf'}}>
                            <h3>No data to show yet... please execute a search first</h3>
                        </div>
                    }
                </div>
            </div>


        )
    }

    private async Search(formId:string,index:number) {
        if(this.state.FormId==null)
        {
            this.setState({
                IsValid:false,
                ErrorMessage:'Form is required'
            });
            return;
        }else{
            this.setState({IsValid:true});
        }

        this.setState({IsBusy:true});
        let result=await WpAjaxPost.Post('search',{FormId:this.state.FormId,StartDate:this.state.StartDate,EndDate:this.state.EndDate,Size:this.state.Size,Page:index});
        this.setState({IsBusy:false});
        let rows:any=this.ProcessRow(result.rows);

        if(result!=null)
        {
            this.setState({
                Form:rednaoEntries.FormList.find(x=>x.Id==formId),
                RowCount:result.count,
                Rows:rows,
                IsBusy:false,
                PageIndex:index
            })
        }else{
            this.setState({IsBusy:false});
        }



    }

    private ProcessRow(rows: any) {
        let entries=[];
        for(let currentRow of rows)
        {
            let entryToCreate:any={};
            entryToCreate._sel=false;
            entryToCreate._date=currentRow.Date;
            entryToCreate._id=currentRow.Id;

            let fields=JSON.parse(currentRow.Entry);
            for(let currentField of fields)
            {
                entryToCreate['f'+currentField._fieldId]=currentField;
            }

            entries.push(entryToCreate);
        }

        return entries;
    }

    private FormatColumn(value:any,column:WPBasicColumnProps,row:any) {
        if(column.PropertyName=='_date')
        {
            return moment(parseFloat(value)*1000).format('MMM-DD-YYYY');
        }

        let field=this.state.Form.Fields.find(x=>'f'+x.Id==column.PropertyName);
        return FormatterFactory.GetFormatter(field,value).Format();




    }

    private async ViewPDF(entryId:number[]) {
        let templates=rednaoEntries.Templates.filter(x=>x.FormId==this.state.Form.Id);
        let selectedTemplate;
        if(templates.length>1||templates.length==0)
        {
            selectedTemplate=await Dialog.Show(<TemplatePicker Templates={templates}/>);
            if(selectedTemplate==null)
                return;
        }else{
            selectedTemplate=templates[0].Id;
        }

        window.open(`${ajaxurl}?_nonce=${rednaoEntries.PDFUtilsNonce}&action=${rednaoEntries._prefix}_create_pdf&data=${JSON.stringify({entryid:entryId,templateid:selectedTemplate})}`);
    }

    private Delete(id: any) {
        DeleteDialog.Show('','Are you sure?',()=>{
            return new Promise<boolean>(async resolve => {
                let result=await WpAjaxPost.Post('delete_entry',{Id:id});
                if(result!=null) {
                    ToastService.SendSuccess('Record deleted successfully');
                    this.setState({
                        Rows:this.state.Rows.filter(x=>x._id!=id)
                    })
                    resolve(true);
                }

                resolve(false);
            })
        })
    }

    private async BulkView() {
        let selectedRows=this.state.Rows.filter(x=>x._sel);
        if(selectedRows.length==0) {
            ToastService.SendErrorMessage('Please select at least a row first');
            return;
        }
        return new Promise<boolean>(async resolve => {
            await this.ViewPDF(selectedRows.map(x=>x._id));
            resolve(false);
        })
    }

    private BulkDownload() {
        return undefined;
    }

    private BulkDelete() {
        return undefined;
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface EntriesBootstrapProps {

}


declare let ajaxurl:string;
interface EntriesBootstrapState {
    FormId:string;
    StartDate:number;
    EndDate:number;
    IsBusy:boolean;
    IsValid:boolean;
    ErrorMessage:string;
    Size:number;
    PageIndex:number;
    Rows:any[];
    Form:FormDTO;
    RowCount:number;

}

for(let field of rednaoEntries.FormList) {

    field.Fields = JSON.parse(field.Fields as any);
}

window.addEventListener('load',()=>{
    ReactDOM.render(<EntriesBootstrap/>,document.getElementById('AppRot'));
});